import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
`;
